import { Injectable } from '@angular/core';

@Injectable()
export class LoadingIndicatorService {
  _loading: boolean;
  constructor() {
    this._loading = false;
   }

  loading(isLoading: boolean): void {
    this._loading = isLoading;
  }

  isloading(): boolean {
    return true;//this._loading;
  }
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/services/loading-indicator.service.ts